export default __webpack_public_path__ + "static/media/wxpay_icon.b90ec4ce.png";